const LOOPBACK_HOSTS: ReadonlySet<string> = new Set(["localhost", "127.0.0.1", "[::1]"]);

/**
 * Validates a user-entered API address for the desktop app. https is required, except for
 * loopback hosts during development. Credentials, query and fragment are rejected.
 * Returns the normalized base URL without a trailing slash, or undefined when unusable.
 */
export function normalizeServerUrl(raw: string): string | undefined {
  const value = raw.trim();
  if (value === "") {
    return undefined;
  }
  const candidate = /^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `https://${value}`;
  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    return undefined;
  }
  if (url.username !== "" || url.password !== "" || url.search !== "" || url.hash !== "") {
    return undefined;
  }
  const loopback = LOOPBACK_HOSTS.has(url.hostname);
  if (url.protocol !== "https:" && !(url.protocol === "http:" && loopback)) {
    return undefined;
  }
  return `${url.origin}${url.pathname}`.replace(/\/+$/, "");
}
